export default __webpack_public_path__ + "static/media/call-of-duty-9130.5aec4495.png";